import { render, staticRenderFns } from "./FireProtectionList.vue?vue&type=template&id=6b96d89a&scoped=true"
import script from "./FireProtectionList.vue?vue&type=script&lang=js"
export * from "./FireProtectionList.vue?vue&type=script&lang=js"
import style0 from "./FireProtectionList.vue?vue&type=style&index=0&id=6b96d89a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b96d89a",
  null
  
)

export default component.exports